import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Box, Tab, Tabs } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import PaymentAPI from 'api/faber/PaymentAPI'
import TabPanel from 'common/TabPanel/TabPanel'
import format from 'date-fns/format'
import { changeMonth } from 'helpers/date'
import OrbitSession from 'hooks/useCookies'
import { AllCustomerPayments } from 'types/api/faber/payment.type'

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  }
}

import { TransformedFaberUserData } from 'types/api/faber/globalCustomers.type'

import PaymentLogsV2 from './PaymentLogsV2'
import RefundRequestV2Tab from './RefundRequestV2Tab'

function FinanceV2OneUser(props: FinanceProfileProps) {
  const [tabValue, setTabValue] = React.useState(0)

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue)
  }
  const handleRefundRequestTabChange = () => {
    setTabValue(1)
  }

  const { customerRow } = props
  // TO DO: fill in this data when design is confirmed
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [customerFinanceData, setCustomerFinanceData] =
    useState<AllCustomerPayments>()

  const { id } = useParams()
  const faberToken = OrbitSession.get('faberToken')
  /*FOR DIFFERENT FORM FIELDS */
  const [endDate] = useState<Date>(changeMonth(new Date(), +3))

  const { data: getAllCustomerPayments } = useQuery(
    ['get-one-customer-payment', id, endDate, customerRow.userEmail],
    async () => {
      return PaymentAPI.getAllCustomerPayments(
        faberToken,
        10,
        0,
        [],
        [],
        [],
        'EMAIL',
        customerRow.userEmail ? customerRow.userEmail : '',
        'desc',
        '2022-10-20',
        format(endDate, 'yyyy-MM-dd')
      )
    },
    {
      onError: () => {
        toast.error('Error getting payment details')
      }
    }
  )

  // gettingAllCustomerPayments is used to get customerFinanceData but customerFinanceData is unused.
  useEffect(() => {
    if (getAllCustomerPayments) {
      const { data: allSubscriptions } = getAllCustomerPayments.data.body
      if (allSubscriptions && allSubscriptions.length === 1) {
        setCustomerFinanceData(allSubscriptions[0])
      }
      if (allSubscriptions && allSubscriptions.length > 1) {
        const filteredSub = allSubscriptions.filter(
          (sub) => sub.MSISDN === customerRow.msisdn
        )
        setCustomerFinanceData(filteredSub[0])
      }
    }
  }, [getAllCustomerPayments])

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Tabs
          sx={{ borderColor: 'divider', mb: 2 }}
          value={tabValue}
          onChange={handleTabChange}
        >
          <Tab label='Transactions' {...a11yProps(0)} sx={{ mr: '10px' }} />
          <Tab label='Refund Requests' {...a11yProps(1)} sx={{ mr: '10px' }} />
        </Tabs>
      </Box>
      <TabPanel value={tabValue} index={0}>
        <PaymentLogsV2
          customerId={id}
          customerRow={customerRow}
          handleRefundRequestTabChange={handleRefundRequestTabChange}
        />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <RefundRequestV2Tab customerId={id} />
      </TabPanel>
    </Box>
  )
}

export default FinanceV2OneUser

interface FinanceProfileProps {
  customerRow: TransformedFaberUserData
}
